// extracted by mini-css-extract-plugin
export default {"root":"SirfWebCheckinReminder-module__root___CnYKq"};